import {makeAutoObservable} from "mobx";
import {socialMediaSubscribeRequest} from "../requests";

export class SocialMediaStore {

    showSocialMediaForm = false;
    sharedPlatform = null;
    lastWordCount = 0;

    constructor(root) {
        this.root = root;
        makeAutoObservable(this);
    }

    closeModal() {
        this.showSocialMediaForm = false;
    }

    // Check if the user has already shared on social media
    hasShared() {
        return localStorage.getItem('socialMediaShared') === 'true';
    }
    // Check if the user has chosen to not show the modal again

    isDontShowAgain() {
        return localStorage.getItem('socialMediaDontShow') === 'true';
    }

    dontShowAgain() {
        localStorage.setItem('socialMediaDontShow', 'true');
        this.showSocialMediaForm = false;
    }

    onShare(platform) {
        // 'linkedin' | 'twitter' | 'facebook'
        this.sharedPlatform = platform;
    }

    // Handle sharing on a social media platform
    // Handle checking sharing and making the API request
    async onCheckSharing(link) {
        if (this.sharedPlatform) {
            await socialMediaSubscribeRequest(this.sharedPlatform, link);
            localStorage.setItem('socialMediaShared', 'true');
            this.showSocialMediaForm = false;
        }
    }
    refreshSocial() {
        if (!this.root.user.isAuthenticated()) return
        const user = this.root.getUser()
        // // Only check if we should show the modal if we have user data
        if (this.lastWordCount === 0 || Number.isNaN(this.lastWordCount)) {
            this.lastWordCount = (Math.floor(user?.used_words_simple_scan / 5000) * 5000);
        }

        const wordCount = user.used_words_simple_scan;

        // Check if the user has reached 9500 words or every 500 words after 10000
        const shouldShowBasedOnWordCount =
            (wordCount >= 9500 && this.lastWordCount < 9500) ||
            (wordCount >= 10000 && (wordCount - this.lastWordCount) >= 5000);

        // Update the last word count
        if (shouldShowBasedOnWordCount) {
            this.lastWordCount = (Math.floor(wordCount / 5000) * 5000);
        }
        console.log(wordCount, this.lastWordCount, shouldShowBasedOnWordCount, this.hasShared(), !this.isDontShowAgain());
        // Show the modal if:
        // 1. The user is not premium
        // 2. They have reached the word count threshold
        // 3. They haven't shared already
        // 4. They haven't chosen to not show the modal again
        // 5. They haven't chosen to be reminded later
        if (shouldShowBasedOnWordCount && !this.hasShared() && !this.isDontShowAgain() && this.isFree()) {
            this.showSocialMediaForm = true;
        }
    }
}
